import {connect} from "react-redux";

import Card from "../../components/Card/Card";
import {handleOpenNavItem} from "../../actions/setNavLink";

const MapStateToProps = (state) => ({
    listCasesWithManager: state.cases.listCasesWithManager,
    listCasesWithContacts: state.cases.listCasesWithContacts,
    listDocuments: state.cases.listDocuments,
    listMessages: state.cases.listMessages,
    listContacts: state.cases.listContacts,
    navItem: state.navLink.navItem
});

const MapDispatchToProps = (dispatch) => ({
    handleOpenNavItem: (string) => {
        dispatch(handleOpenNavItem(string));
    },
});

export default connect(MapStateToProps, MapDispatchToProps)(Card);